import { styled } from 'parkdepot-shared'

export const DeleteSubscriptionContainer = styled('div', ({ $theme }) => ({
    marginTop: '4rem',
    marginBottom: '2rem',
    padding: '0 1.6rem'
}))

export const CancelModalContent = styled('div', ({ $theme }) => ({
    ...$theme.typography.ParagraphSmall,
    display: 'flex',
    flexDirection: 'column'
}))

export const SelectArrowIcon = styled('i', ({ $theme }) => ({
    color: '#667085',
    fontSize: '1.6rem'
}))

export const ModalTitle = styled('h3', ({ $theme }) => ({
    margin: 0,
    fontSize: '2.2rem',
    fontWeight: 700,
    lineHeight: '3.2rem',
    marginBottom: '0.8rem'
}))

export const ContentReasonText = styled('div', ({ $theme }) => ({
    fontSize: '1.4rem',
    fontWeight: 300,
    lineHeight: '2rem',
    margin: '0.8rem 0'
}))

export const CancelModalButtonContainer = styled('div', ({ $theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '2rem',
    marginTop: '2rem'
}))

export const BaseButtonOverrides = {
    style: {
        width: '100%',
        backgroundColor: '#FE2C3E',
        borderColor: '#FE2C3E',
        color: '#fff',
        borderRadius: '5rem',

        ':hover': {
            backgroundColor: '#FE2C3E',
            color: '#fff'
        },

        ':focus': {
            backgroundColor: '#FE2C3E',
            color: '#fff'
        },

        ':active': {
            backgroundColor: '#FE2C3E',
            color: '#fff'
        }
    }
}

export const SelectOverrides = {
    ControlContainer: {
        style: {
            border: '1px solid #EAECF0',
            borderRadius: '8px'
        }
    },
    Placeholder: {
        style: {
            color: '#AFAFAF'
        }
    },
    DropdownListItem: {
        style: {
            ':hover': {
                backgroundColor: '#F6F6F6'
            }
        }
    }
}

export const OnSubmitModalOverride = {
    BaseButton: {
        style: {
            width: '100%',
            height: '5rem',
            backgroundColor: '#FE2C3E',
            borderColor: '#FE2C3E',

            ':hover': {
                backgroundColor: '#FE2C3E'
            },
            ':focus': {
                backgroundColor: '#FE2C3E'
            },
            ':active': {
                backgroundColor: '#FE2C3E'
            }
        }
    }
}

export const CancelModalButtonOverrides = {
    BaseButton: {
        style: {
            width: '100%',
            height: '5rem'
        }
    }
}
